export default "__VITE_ASSET__sR6pJWLH__"